import { freshModal } from "../freshModal";
import React, { useState } from "react";
import Modal from "./Modal";

const AddRatingModalFormSession = ({ isOpen, onClose, onSave, candidateId }) => {
  const [formData, setFormData] = useState({
    rating: 3,
    skills: 3,
    punctuality: 3,
    attitude: 3,
    missionId: "",
    comments: "",
    candidateId,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]:
        name === "rating" ||
        name === "skills" ||
        name === "punctuality" ||
        name === "attitude"
          ? parseInt(value)
          : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  const RatingInput = ({ name, label, value }) => (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label}
      </label>
      <div className="flex items-center space-x-2">
        <input
          type="range"
          name={name}
          min="1"
          max="5"
          value={value}
          onChange={handleChange}
          className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
        />
        <span className="text-gray-700 min-w-[20px] text-center">{value}</span>
      </div>
    </div>
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Ajouter une évaluation"
      className="max-w-xl"
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label
            htmlFor="missionId"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Mission concernée
          </label>
          <select
            id="missionId"
            name="missionId"
            required
            value={formData.missionId}
            onChange={handleChange}
            className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          >
            <option value="">Sélectionnez une mission</option>
            <option value="mission1">
              Développeur chez Client A (Jan 2025)
            </option>
            <option value="mission2">
              Chef de projet chez Client B (Mar 2025)
            </option>
          </select>
        </div>

        <div className="space-y-3">
          <RatingInput
            name="rating"
            label="Évaluation globale"
            value={formData.rating}
          />
          <RatingInput
            name="skills"
            label="Compétences techniques"
            value={formData.skills}
          />
          <RatingInput
            name="punctuality"
            label="Ponctualité"
            value={formData.punctuality}
          />
          <RatingInput
            name="attitude"
            label="Attitude professionnelle"
            value={formData.attitude}
          />
        </div>

        <div>
          <label
            htmlFor="comments"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Commentaires
          </label>
          <textarea
            id="comments"
            name="comments"
            rows={4}
            value={formData.comments}
            onChange={handleChange}
            className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Points forts, points d'amélioration..."
          />
        </div>

        <div className="flex justify-end space-x-3 pt-4">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50"
          >
            Annuler
          </button>
          <button
            type="submit"
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            Enregistrer
          </button>
        </div>
      </form>
    </Modal>
  );
};

export const AddRatingModal = freshModal(AddRatingModalFormSession, "isOpen");
